import React from "react";
import {FormattedMessage} from "react-intl";
import PrivacyPolicy from "../../../../common/js/components/privacy-policy";

class Footer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            privacyModal: false
        }
    }

    togglePrivacyModal = () => {
        this.setState({ privacyModal: !this.state.privacyModal })
    };

    render() {
        return (
            <footer className='gasnet_footer'>
                <div className='container'>
                    GasNet <span className='ml-2 mr-2'>|</span> <a href='https://www.gasnet.cz/-/media/GasNet/Files/Gasnet/gdpr/IM_pro_subjekty_udaju_HR_Onboarding.pdf' className='text-gray' target="_BLANK"><FormattedMessage id='app.footer.gdpr'/></a>
                </div>
            </footer>
        )
    }
}

export default Footer;
